export const getProfessionalBestInDentalStorageKey = (id: string) =>
  `isProfessionalBestInDentalPopUpShown-${id}`;
